import { SyntheticEvent } from 'react';
import { DONATION_BOX_SELECTOR } from '../../common-components/component-library/payment/constants';

export function smoothScrollToElement(selector: string, yOffset: number) {
  const element = document.querySelector(selector);
  let y;
  if (element) {
    y = Math.floor(element.getBoundingClientRect().top + window.pageYOffset + yOffset);
    window.smoothScrollingTo = y;
    window.scrollTo({ top: y, behavior: 'smooth' });
  }
}

export function scrollToDonationBox(event?: SyntheticEvent) {
  if (event) {
    event.preventDefault();
  }

  smoothScrollToElement(DONATION_BOX_SELECTOR, 0);
}
